import { InjectionToken } from "@angular/core";
import { LogLevel } from "@webapp/core/logging/models/logging.models";
import { IChargebeeItem } from "../../../../../../server/src/config";

export interface IEnvironmentConfig {
  name: string;
  dc: string;
  type: "cloud" | "onprem";
  bypassDomainCheck?: boolean;
}

export type IAuthConfig = IAuth0AuthConfig;

export interface IAuth0AuthConfig {
  type: "auth0";
  mainUsersDatabaseName: string;
  domainsAllowedForSignup: string[];
  dc: { [name: string]: { domain: string; clientId: string; audience: string } };
}

export interface IChargebeeConfig {
  enabled: boolean;
  site?: string;
  sites?: IChargebeeItem[];
}

export interface IDelightedConfig {
  enabled: boolean;
  tags?: string[];
}

export interface IEndpointsConfig {
  secure: boolean;
  apiEndpoint: string;
  webappEndpoint: string;
  websiteEndpoint: string;
}

export interface ILoggingConfig {
  enabled: boolean;
  tags: ILoggingConfigTags;
  endpoint: string;
  levels: LogLevel[];
}

export interface ILoggingConfigTags {
  dc: string;
  env: string;
}

export interface ISegmentConfig {
  enabled: boolean;
  writekey?: string;
}

export interface ICdnStorageConfig {
  enabled: boolean;
  url: string;
}

export interface ILaunchDarklyConfig {
  enabled: boolean;
  clientKey?: string;
  proxyBaseUrl?: string;
  eventBaseUrl?: string;
}

export interface IAppConfig {
  env: IEnvironmentConfig;
  auth: IAuthConfig;
  chargebee: IChargebeeConfig;
  delighted: IDelightedConfig;
  delightedCES: IDelightedConfig;
  delightedNewNavi: IDelightedConfig;
  endpoints: IEndpointsConfig;
  logging: ILoggingConfig;
  segment: ISegmentConfig;
  cdnStorage: ICdnStorageConfig;
  clickMagick: boolean;
  launchDarkly: ILaunchDarklyConfig;
}

export const APP_CONFIG = new InjectionToken<IAppConfig>("AppConfig", {
  providedIn: "root",
  factory: (): IAppConfig => webappConfig(),
});
